import React from 'react'
import Backdrop, { BackdropProps } from '@mui/material/Backdrop'

/**
 * Custom Backdrop to prevent background scrolling on iOS devices.
 */
const CustomBackdrop: React.FC<BackdropProps> = props => {
	const handleTouchMove = (event: React.TouchEvent<HTMLDivElement>) => {
		event.preventDefault() // Prevent scrolling behind the backdrop
	}

	return (
		<Backdrop
			data-testid={'custom-backdrop'}
			{...props}
			onTouchMove={handleTouchMove}
		/>
	)
}

export default CustomBackdrop
